import {ModeAddType} from "@/common/glboalconstant";

export class BizUtil {
  public static isControlWeight(addType) {
    return (addType == 3 || addType == ModeAddType.ControlWeight);
  }

  public static getCarNo(data) {
    debugger
    if (data.car) {
      if (data.car.indexOf('-')) {
        var cars = data.car.split('-')
        let c_start = cars[0]
        let c_end = cars[1]
        if (c_start == c_end) {
          return `1-${c_start}`
        }
        if (c_start < c_end) {
          let items = []
          for (let i = c_start; i <= c_end; i++) {
            items.push(`1-${i}`)
          }
          return items.join(',')
        } else {
          let items = []
          items.push(`1-${c_start}`)
          for (let i = 1; i <= c_end; i++) {
            items.push(`1-${i}`)
          }
          return items.join(',')
        }

      }
    }
    return '';
  }
}
